import { useEffect, useState } from "react";

import { useAppSelector, useAppThunkDispatch } from "store";

import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Loader } from "components/Loader/Loader";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNext from "@mui/icons-material/NavigateNext";
import { TableComponent } from "components/TableComponent/TableComponent";
import {
  getOtpRecordsThunk,
  toggleOtpRecordThunk,
} from "store/features/thunk/otpRecordThunk/otpRecordThunk";

import { sortOtpRecords, updateOtpRecordInState } from "./utils";

const headers: string[] = [
  "USER INFO",
  "DEVICE ID",
  "TYPE",
  "CODE",
  "SHARED",
  "STATUS",
];

export const OtpDashboardComponent = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { otpRecords } = useAppSelector(({ otpRecord }) => otpRecord);
  const dispatchThunk = useAppThunkDispatch();

  const sortedOtpRecords = sortOtpRecords(otpRecords);

  useEffect(() => {
    handleOtpRecords();
  }, []);

  const handleOtpRecords = async () => {
    setIsLoading(true);
    await dispatchThunk(getOtpRecordsThunk());
    setIsLoading(false);
  };

  const handleToggle = async (id: string, isShared: boolean) => {
    updateOtpRecordInState(id, { isShared });

    setIsLoading(true);
    await dispatchThunk(toggleOtpRecordThunk({ id, isShared }));
    setIsLoading(false);
  };

  return (
    <>
      <Loader isLoading={isLoading} />
      <Box className="flex flex-col gap-5" sx={{ padding: "0 50px 0 305px" }}>
        <Box
          className="flex justify-between border-b"
          sx={{ borderColor: "divider" }}
        >
          <Stack spacing={2}>
            <Breadcrumbs
              aria-label="breadcrumb"
              separator={<NavigateNext fontSize="small" color="success" />}
            >
              <Typography color="text.primary" className="py-3.5">
                OTP Dashboard
              </Typography>
            </Breadcrumbs>
          </Stack>
        </Box>

        <Box display="flex" marginLeft="auto">
          <Button
            variant="contained"
            color="success"
            onClick={handleOtpRecords}
          >
            Refresh
          </Button>
        </Box>

        <TableComponent
          type="otpRecords"
          headers={headers}
          rows={sortedOtpRecords}
          onToggle={handleToggle}
        />
      </Box>
    </>
  );
};
